import {createReducer, on} from "@ngrx/store";
import * as TradeRoutesActions from './trade-routes.actions';
import {TradeRoute} from "../../models/TradeRoute";
export const tradeRoutesFeatureKey = 'tradeRoutes';
export const tradeRoutesInitialState: TradeRoute[] = null;
export const TradeRoutesReducer = createReducer<TradeRoute[] | null>(
  tradeRoutesInitialState,
  on(TradeRoutesActions.update, (_state, { tradeRoutes }) => tradeRoutes),
);
